import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "field has-addons has-addons-centered monizze-autocomplete tooltipSearch",
  style: {"margin-bottom":"0"}
}
const _hoisted_2 = {
  key: 0,
  id: "tooltipBox"
}
const _hoisted_3 = { class: "control" }
const _hoisted_4 = { class: "control has-icons-right " }
const _hoisted_5 = ["disabled", "placeholder"]
const _hoisted_6 = {
  key: 1,
  class: "control has-icons-right"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "dropdown-content"
}
const _hoisted_9 = ["onKeyup", "onClick"]
const _hoisted_10 = { class: "control has-icons-right" }
const _hoisted_11 = ["disabled", "placeholder"]
const _hoisted_12 = { class: "control" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-right" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "control" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-right" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" })
], -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasicSelectComponent = _resolveComponent("BasicSelectComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$setup.vouchersStore.getters.getSelected && !$setup.categoryStore.getters.getSelected)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($setup.t("search.voucher.tooltip")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_3, [
      _createVNode(_component_BasicSelectComponent, {
        modelValue: $setup.search_type,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ($setup.search_type = $event)),
          $setup.setSearchType
        ],
        "is-disabled": $props.isDisabled ,
        highlight: true,
        options: $setup.options,
        key: "search_type",
        "dropdown-arrow-orientation": "right"
      }, {
        "default-not-selected-option": _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString($setup.t("nearby")), 1)
        ]),
        option: _withCtx(({ option }) => [
          _createTextVNode(_toDisplayString(option.label), 1)
        ]),
        "selected-option": _withCtx(({ option }) => [
          _createTextVNode(_toDisplayString(option.label), 1)
        ]),
        "no-options": _withCtx(({}) => [
          _createTextVNode(_toDisplayString($setup.t("message.no_available_options")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "is-disabled", "options", "onUpdate:modelValue"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        id: "autocomplete-search-input",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ($setup.search_criteria = $event)),
        class: _normalizeClass([{ 'is-disabled': $setup.isInputDisabled }, "input has-text-black-bis has-text-weight-bold "]),
        disabled: $setup.isInputDisabled,
        placeholder: _ctx.$t('autocomplete.placeholder'),
        type: "text",
        autocomplete: "off",
        onInput: _cache[2] || (_cache[2] = ($event: any) => ($setup.onInput($setup.search_criteria))),
        onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => ($setup.onEnter && $setup.onEnter(...args)), ["enter"]))
      }, null, 42, _hoisted_5), [
        [_vModelText, $setup.search_criteria]
      ])
    ], 512), [
      [_vShow, $setup.search_type.valueOf() == 'location']
    ]),
    ($setup.search_type.valueOf() == 'name')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ($setup.search_criteria = $event)),
            class: _normalizeClass([{ 'is-disabled': $setup.isInputDisabled}, "input has-text-black-bis has-text-weight-bold"]),
            placeholder: _ctx.$t('search.criteria'),
            type: "text",
            onInput: _cache[5] || (_cache[5] = ($event: any) => ($setup.onInput($setup.search_criteria))),
            onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => ($setup.onEnter && $setup.onEnter(...args)), ["enter"]))
          }, null, 42, _hoisted_7), [
            [_vModelText, $setup.search_criteria]
          ]),
          ($setup.nameAutoComplete.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nameAutoComplete.valueOf(), (placeName) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: placeName,
                    class: "dropdown-item",
                    onKeyup: _withKeys(($event: any) => ($setup.selectName(placeName)), ["enter"]),
                    onClick: ($event: any) => ($setup.selectName(placeName))
                  }, _toDisplayString(placeName), 41, _hoisted_9))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_10, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ($setup.search_criteria = $event)),
        class: _normalizeClass([{ 'is-disabled': $setup.isInputDisabled}, "input "]),
        disabled: $setup.isInputDisabled || $setup.search_type.valueOf()=='nearby',
        placeholder: _ctx.$t('search.criteria'),
        type: "text",
        onInput: _cache[8] || (_cache[8] = ($event: any) => ($setup.onInput($setup.search_criteria))),
        onKeyup: _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => ($setup.onEnter && $setup.onEnter(...args)), ["enter"]))
      }, null, 42, _hoisted_11), [
        [_vModelText, $setup.search_criteria]
      ])
    ], 512), [
      [_vShow, $setup.search_type.valueOf() == 'nearby']
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        class: _normalizeClass([{ 'is-disabled': $setup.isInputDisabled }, "button has-background-white is-search"]),
        disabled: $setup.isInputDisabled,
        type: "button",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.onEnter && $setup.onEnter(...args)))
      }, _hoisted_15, 10, _hoisted_13)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        class: _normalizeClass([{ 'is-disabled': $setup.isInputDisabled }, "button has-background-white has-text-black-bis"]),
        disabled: $setup.isInputDisabled,
        type: "button",
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.onClear && $setup.onClear(...args)))
      }, _hoisted_19, 10, _hoisted_17)
    ])
  ]))
}